import { AsyncHelper } from 'src/app/helpers/async.helper';
import { IFile } from 'src/app/interfaces/io/file.interface';
import { ILaunchSettings } from 'src/app/interfaces/io/launch-settings.interface';
import { VfmService } from '../../io/vfm.service';
import { ILauncher } from './launcher.interface';

export class HrefLauncher implements ILauncher {
  constructor(private vfm: VfmService) {
  }

  async launch(file: IFile, path: string, settings?: ILaunchSettings): Promise<any> {
    const content = await this.vfm.readTextFile(path);

    const json = JSON.parse(content) as {
      "href": string,
      "target": "_blank" | "_system"
    };

    await AsyncHelper.wait(1000);

    window.open(json.href, json.target);

    return true;
  }
}
